module.exports = "/fonts/vendor/material-design-icons-icondist/MaterialIcons-Regular.ttf?24a6611c28f373a0e1d7232b5e0ecbc1";